// Come si descrive una notifica: chiavi i18n (titolo e testo), parametri e icona, dal tipo e dai parametri salvati (il testo non è salvato). Usato dall'interfaccia
// (campanella, pagina) e dal server (email e push), così le due versioni non possono divergere. Funzione pura, solo import relativi con estensione.
import type { EventoNotificaApi, NotificaApi } from "../data-model/notifica_api.ts";

export interface DescrizioneNotifica {
  icona: string;
  chiaveTitolo: string;
  /** Riga di testo sotto il titolo; assente se il titolo basta. */
  chiaveTesto: string | null;
  parametri: Record<string, string | number>;
}

const ICONE_EVENTO: Record<EventoNotificaApi, string> = {
  quadro_offline: "fal fa-plug-circle-xmark",
  quadro_online: "fal fa-plug-circle-check",
  persona_in_campo: "fal fa-person-digging",
  persona_uscita: "fal fa-person-walking-arrow-right",
  vento_forte: "fal fa-wind",
  vento_rientrato: "fal fa-wind",
};

const testo = (v: unknown): string => (typeof v === "string" || typeof v === "number" ? String(v) : "");

/** Chiavi i18n e parametri per titolo e testo di una notifica, dal tipo e dai parametri salvati. */
export function descriviNotifica(n: Pick<NotificaApi, "tipo" | "evento" | "parametri">): DescrizioneNotifica {
  const p = n.parametri ?? {};
  if (n.tipo === "allarme") {
    const dispositivo = testo(p.nome_dispositivo) || testo(p.identificativo) || "—";
    return {
      icona: "fal fa-triangle-exclamation",
      chiaveTitolo: "centro_notifiche.tipi.allarme.titolo",
      chiaveTesto: p.bloccante === true ? "centro_notifiche.tipi.allarme.testo_bloccante" : "centro_notifiche.tipi.allarme.testo",
      parametri: { dispositivo, codice: testo(p.codice) || "—" },
    };
  }
  if (n.tipo === "evento" && n.evento) {
    const quadro = testo(p.nome_quadro) || testo(p.codice_locale) || "—";
    return {
      icona: ICONE_EVENTO[n.evento],
      chiaveTitolo: `centro_notifiche.tipi.evento.${n.evento}.titolo`,
      chiaveTesto: `centro_notifiche.tipi.evento.${n.evento}.testo`,
      parametri: { quadro, velocita: testo(p.velocita_ms) || "—", soglia: testo(p.soglia_ms) || "—" },
    };
  }
  if (n.tipo === "allerta_meteo") return { icona: "fal fa-cloud-bolt", chiaveTitolo: "centro_notifiche.tipi.allerta_meteo.titolo", chiaveTesto: null, parametri: {} };
  return { icona: "fal fa-circle-info", chiaveTitolo: "centro_notifiche.tipi.sistema.titolo", chiaveTesto: null, parametri: {} };
}
